import T from "../theme/colors";

export default function Spinner({ size = 20, color }) {
  return (
    <span style={{
      display: "inline-block",
      width: size, height: size,
      border: `2px solid ${color || "var(--border)"}`,
      borderTopColor: color || "var(--primary)",
      borderRadius: "50%",
      animation: "spin 0.7s linear infinite",
      flexShrink: 0,
    }} />
  );
}

export function PageSpinner() {
  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: 300, flexDirection: "column", gap: 12,
    }}>
      <Spinner size={28} />
      <span style={{ fontSize: 15, color: "#9C9790" }}>Loading...</span>
    </div>
  );
}
